<div class="tw:flex tw:flex-col-reverse tw:sm:flex-row tw:gap-4 tw:w-full">
  <button
    [vee-btn]="cancelDanger ? 'filled' : 'outlined'"
    [class]="
      (cancelDanger ? 'red btn-cancel-outline' : 'tw:text-grey-darker') +
      ' tw:flex-1 tw:max-w-none! tw:min-w-max'
    "
    (click)="cancel.emit()"
  >
    {{ cancelLabel || ("COMPONENTS.CANCEL" | translate) }}
  </button>
  <button
    vee-btn="filled"
    class="cyan tw:flex-1 tw:max-w-none! tw:min-w-max"
    [disabled]="saveDisabled"
    (click)="save.emit()"
  >
    {{ saveLabel || ("COMPONENTS.SAVE" | translate) }}
  </button>
</div>
